<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('rfqs.create')" @invoke-method="invokeMethod($event)" action="openRfqForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetRfqs(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="rfq_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="rfqs" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openRfqForm(props.item)">
                                <td>{{ props.item.rfq_id }}</td>
                                <td>{{ props.item.vendor }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.rfq_date }}</td>
                                <td>{{ props.item.reference_number }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="rfqs"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="rfq_dialog">
                <v-card>
                    <v-form ref="form_rfq">
                        <v-card-title>
                            <span class="headline">{{ rfq.rfq_id ? $t("lang.edit_rfq") : $t("lang.add_rfq") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeRfqDialog"
                                :dialog-status="rfq_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <!-- fields would go here for the dialog -->
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="rfq.rfq_id" color="error" @mouseup.left="$refs.delete_rfqs.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeRfqDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveRfqs">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_rfqs"
                :heading="$t('lang.delete_rfq')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteRfqs(rfq.rfq_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import { ClientRequest } from "http";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openRfqForm" },
                { title: this.$t("lang.refresh"), action: "dbGetRfqs", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.rfq_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.vendor"), sortable: false, width: "25%" },
                { text: this.$t("lang.customer"), sortable: false, width: "25%" },
                { text: this.$t("lang.rfq_date"), sortable: false, width: "15%" },
                { text: this.$t("lang.reference_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.status_id"), sortable: false, align: "center", width: "8%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            rfq: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            rfq_dialog: false,
            dbGetRfqs: _.debounce(this.getRfqs, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchRfqs", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.rfqs) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchRfqs({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.rfqs) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetRfqs");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.rfqs.rfqs_filter,
            page: (state) => state.rfqs.page,
            rules_rfqs: (state) => state.rfqs.rules_rfqs,
            rfq_status_options: (state) => state.settings.rfq_status_options,
            rfq_status: (state) => state.options_categories.rfq_status,
            rfqs: (state) => state.rfqs.rfqs,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchRfqs", "saveRfq", "deleteRfq", "fetchOptions"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openRfqForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "rfq", params: { id: item.rfq_id } });
            } else {
                this.$router.push({ name: "rfq" });
            }
        },
        saveRfqs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_rfq")) {
                    let body = this.prepForm(this.rfq, this.rules_rfqs);

                    this.saveRfq({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getRfqs();
                                this.closeRfqDialog();
                            } else {
                                this.$router.push({ name: "rfq", params: { id: data.rfq_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteRfqs(id = null) {
            this.deleteRfq({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getRfqs();
                    this.closeRfqDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeRfqDialog() {
            this.rfq_dialog = false;
            this.$refs.delete_rfqs.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getRfqs(pg_refresh = false) {
            this.startLoader();

            this.fetchRfqs({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.rfq_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.rfq_status == 0 || force == true) await this.fetchOptions({ body: { slug: "rfq_status", options: 1 } });

            this.finishLoader();
        },
    },
    created() {},
};
</script>
